import React from "react";
import MainPage from "./pages/Main/MainPage";
import { GlobalStyles } from "./styles/GlobalStyles";

const App = () => {
	return (
		<>
			<GlobalStyles />
			<MainPage />
		</>
	);
};

export default App;
